<template>
  <div>
    <div class="d-flex">
      <h1 class="mb-3 mr-auto">{{ project.title }}</h1>
      <div class="align-self-center">
        <b-button variant="outline-primary" @click="editProject">
          <b-icon icon="pencil-square"></b-icon>Edit
        </b-button>
      </div>
    </div>
    <b-card class="mb-3">
      <b-row>
        <b-col cols md="4">
          <b-card-img :src="logo" fluid class="mb-2"></b-card-img>
        </b-col>
        <b-col cols md="8">
          <h4 class="card-title">Basic Information</h4>
          <div>
            Grant:
            <b>
              <a :href="grantWebsite" target="_blank">{{ project.grant && project.grant.name}}</a>
            </b>
          </div>
          <div>
            Period:
            <b>{{ startDate | moment('D.M.YYYY') }} - {{ endDate | moment('D.M.YYYY') }}</b>
          </div>
          <div>
            Approved funds:
            <b>{{ project.budget }}</b>
            {{ project.currency}}
          </div>
          <div>
            Category:
            <b>{{ project.category}}</b>
          </div>
          <div>
            Location:
            <b>{{ project.location}}</b>
          </div>
          <div>
            Website:
            <a :href="project.website" target="_blank">{{ project.website }}</a>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mb-3" title="Project Brief">
      <p>{{ project.about }}</p>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ["project"],
  data() {
    return {};
  },
  created() {},
  computed: {
    logo() {
      return this.project.image || "";
    },
    grantWebsite() {
      return this.project.grant ? this.project.grant.website : "";
    },
    startDate() {
      return this.project.start_date ? this.project.start_date : new Date();
    },
    endDate() {
      return this.project.end_date ? this.project.end_date : new Date();
    }
  },
  methods: {
    editProject() {
      this.$emit("edit-project");
    }
  }
};
</script>

<style>
</style>